 <template>
  <div class="container mt-4" dir="rtl">
    
    <div class="card shadow-sm border-top-success">
      <div class="card-header bg-white py-3">
        <h5 class="m-0 fw-bold text-success">
          <i class="fas fa-file-export ms-2"></i> مركز تصدير البيانات (Excel)
        </h5>
      </div>
      
      <div class="card-body">
        
        <div class="alert alert-info border-info d-flex align-items-center">
            <i class="fas fa-info-circle fa-2x ms-3 text-info"></i>
            <div>
                <strong>تنبيه:</strong> سيتم تصدير ملف يحتوي على جميع بيانات الطلاب بالتنسيق الوزاري المطلوب.
                <br>الأعمدة: (Student Code, Arabic Name, School Code, ... etc).
            </div>
        </div>

        <div class="row justify-content-center mt-5 mb-5">
            <div class="col-md-6 text-center">
                
                <!-- <img src="/img/excel_icon.png" alt="Excel" class="mb-3" style="width: 80px; opacity: 0.8;"> -->
                
                <h4 class="fw-bold mb-3">تصدير قاعدة بيانات الطلاب</h4>
                
                <div class="d-grid gap-2 col-8 mx-auto">
                    <button @click="downloadExcel" class="btn btn-success btn-lg shadow fw-bold" :disabled="loading">
                        <span v-if="loading">
                            <span class="spinner-border spinner-border-sm ms-2"></span> جاري التجهيز...
                        </span>
                        <span v-else>
                            <i class="fas fa-download ms-2"></i> تحميل الملف (.xlsx)
                        </span>
                    </button>
                </div>
                
                <p class="text-muted mt-3 small">
                    * قد تستغرق العملية دقيقة حسب سرعة الاتصال وحجم البيانات.
                </p>

            </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "ExportDataCenter",
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async downloadExcel() {
      this.loading = true;
      try {
        const response = await api.get('/admin/export/students-custom', {
            responseType: 'blob' // ضروري جداً للملفات
        });

        // إنشاء رابط التحميل
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `كشوف المناداه 3340000.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
      } catch (error) {
        alert("حدث خطأ أثناء التصدير");
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.border-top-success { border-top: 4px solid #198754; }
</style>